import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  token: string | null;
  userName: string | null;
  triggerNavbarReload: boolean; // ✅ This will help trigger re-render
}

const initialState: AuthState = {
  token: localStorage.getItem("token"),
  userName: localStorage.getItem("username"),
  triggerNavbarReload: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<{ token: string; userName: string }>) => {
      state.token = action.payload.token;
      state.userName = action.payload.userName;
      state.triggerNavbarReload = !state.triggerNavbarReload; // ✅ Toggle the value to force re-render
    },
    logout: (state) => {
      state.token = null;
      state.userName = null;
      localStorage.removeItem("token");
      localStorage.removeItem("username");
      state.triggerNavbarReload = !state.triggerNavbarReload; // ✅ Toggle the value to force re-render
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;
